var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStripe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 70,
    viewBox: "0 0 167 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.37 35.6988C166.37 23.8917 160.651 14.5752 149.72 14.5752C138.743 14.5752 132.102 23.8917 132.102 35.6066C132.102 49.4892 139.942 56.4996 151.196 56.4996C156.684 56.4996 160.835 55.2544 163.972 53.5017V44.2774C160.835 45.8456 157.238 46.8141 152.672 46.8141C148.198 46.8141 144.232 45.246 143.724 39.8037H166.278C166.278 39.2041 166.37 36.8058 166.37 35.6988ZM143.586 31.3173C143.586 26.1056 146.768 23.9379 149.674 23.9379C152.487 23.9379 155.485 26.1056 155.485 31.3173H143.586Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.299 14.5752C109.779 14.5752 106.873 16.6968 105.259 18.1727L104.659 15.3131H94.5125V69.0908L106.043 66.6464L106.089 53.594C107.749 54.7931 110.194 56.4996 114.252 56.4996C122.508 56.4996 130.026 49.8581 130.026 35.2376C129.98 21.8624 122.37 14.5752 114.299 14.5752ZM111.531 46.3529C108.81 46.3529 107.196 45.3844 106.089 44.1852L106.043 27.0741C107.242 25.7366 108.902 24.8142 111.531 24.8142C115.728 24.8142 118.634 29.5186 118.634 35.5605C118.634 41.7408 115.774 46.3529 111.531 46.3529Z",
    fill: "#635BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.647 11.8537L90.2235 9.36315V0.000488281L78.647 2.44493V11.8537Z",
    fill: "#635BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2235 15.3594H78.647V55.7157H90.2235V15.3594Z",
    fill: "#635BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.24 18.772L65.502 15.3591H55.5398V55.7154H67.0702V28.3653C69.7913 24.814 74.4035 25.4597 75.8333 25.967V15.3591C74.3574 14.8056 68.9611 13.7909 66.24 18.772Z",
    fill: "#635BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1792 5.35059L31.9255 7.7489L31.8794 44.6922C31.8794 51.5182 36.9989 56.5454 43.8249 56.5454C47.6068 56.5454 50.3741 55.8536 51.8961 55.0234V45.6608C50.4202 46.2603 43.133 48.3819 43.133 41.556V25.1828H51.8961V15.359H43.133L43.1792 5.35059Z",
    fill: "#635BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0013 27.0741C12.0013 25.2754 13.4771 24.5836 15.9216 24.5836C19.4268 24.5836 23.8545 25.6444 27.3597 27.5353V16.6968C23.5316 15.1748 19.7497 14.5752 15.9216 14.5752C6.55892 14.5752 0.33252 19.4641 0.33252 27.6276C0.33252 40.3571 17.8587 38.3278 17.8587 43.8162C17.8587 45.9378 16.0138 46.6296 13.431 46.6296C9.60294 46.6296 4.71406 45.0615 0.839855 42.9399V53.9168C5.12915 55.7617 9.46458 56.5458 13.431 56.5458C23.0243 56.5458 29.6197 51.7952 29.6197 43.5395C29.5735 29.7953 12.0013 32.2397 12.0013 27.0741Z",
    fill: "#635BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/Stripe.1eda9c47c8530cc2d7a464f64237f1c2.svg";
export { ForwardRef as ReactComponent };